import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './index';

// Initialize i18next only once
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: localStorage.getItem('language') || 'en', // Use localStorage as initial language
      fallbackLng: 'en',
      interpolation: { 
        escapeValue: false 
      },
      debug: process.env.NODE_ENV === 'development', // Enable debug in development
    });
}

// Export the i18n instance for direct use
export { i18n };

// Keep the default export for backward compatibility, but it's simpler now
export default i18n;
